// eslint-disable-next-line import/prefer-default-export
export function getTimeSince(ISOStringDate) {
  const rtf1 = new Intl.RelativeTimeFormat('sv', { numeric: 'always', style: 'long' });

  const posted = new Date(ISOStringDate);
  const today = new Date();
  const diffInMS = today.getTime() - posted.getTime();
  const wholeDaysSince = Math.floor(diffInMS / 86400000);
  const wholeYearsSince = Math.floor(wholeDaysSince / 365);

  // Difference is more than a year
  if (wholeYearsSince > 0) {
    return rtf1.format(-1 * wholeYearsSince, 'years');
  }

  // Difference is less than a year
  const monthDiff = today.getMonth() - posted.getMonth();
  const areSameCalendarYear = today.getFullYear() === posted.getFullYear();
  const wholeMonthsSince = areSameCalendarYear ? monthDiff : 12 + monthDiff;
  if (wholeMonthsSince > 0) {
    return rtf1.format(-1 * wholeMonthsSince, 'months');
  }

  // Difference is less than a month
  const wholeWeeksSince = Math.floor(wholeDaysSince / 7);
  if (wholeWeeksSince > 0) {
    return rtf1.format(-1 * wholeWeeksSince, 'weeks');
  }

  // Difference is less than a week
  if (wholeDaysSince > 0) {
    return rtf1.format(-1 * wholeDaysSince, 'days');
  }

  // Difference is less than a day
  const wholeHoursSince = Math.floor(diffInMS / 3600000);
  if (wholeHoursSince > 0) {
    return rtf1.format(-1 * wholeHoursSince, 'hours');
  }

  const wholeMinutesSince = Math.floor(diffInMS / 60000) || 1;
  return rtf1.format(-1 * wholeMinutesSince, 'minutes');
}
